import { USER_LOGIN, USER_LOGOUT, USER_REGISTER, FORGOT_PASSWORD,
  UPDATELOGGEDINUSER, USER_PROFILE, CHANGE_PASSWORD, RESET_PASSWORD,
  USER_LOGIN_OTP, SEND_OTP, GET_USER_PROFILE } from '../actions/user'
import Vue from 'vue'
import { RepositoryFactory } from '../repositories/RepositoryFactory'

const UserRepository = RepositoryFactory.get('user')
const state = {
  status: '',
  isLoggedIn: false,
  loggedInUser: {},
  showToast: false
}

const mutations = {
  [USER_LOGIN]: (state, {token, loginModalRef, user, fromRegister}) => {
    localStorage.setItem('token', token)
    state.isLoggedIn = true
    if (loginModalRef) {
      loginModalRef.click()
    }
    state.loggedInUser = user
    localStorage.setItem('user', JSON.stringify(user))
    localStorage.removeItem('financialObjTemp')
    localStorage.removeItem('codesObject')
    localStorage.removeItem('inputOneSelectedData')
    localStorage.removeItem('outputData')
    localStorage.removeItem('financial_statment_key')
    localStorage.removeItem('displayInfo')
    // Vue.routerInstance.push('/financial-statements')
    if (fromRegister) {
      Vue.routerInstance.push('/financialStatmentsTranslation-plans')
    } else {
      Vue.routerInstance.push('/')
    }
  },
  [USER_LOGIN_OTP]: (state, {token, user}) => {
    localStorage.setItem('token', token)
    state.isLoggedIn = true
    state.loggedInUser = user
    localStorage.setItem('user', JSON.stringify(user))
    localStorage.removeItem('financialObjTemp')
    localStorage.removeItem('codesObject')
    localStorage.removeItem('inputOneSelectedData')
    localStorage.removeItem('outputData')
    localStorage.removeItem('financial_statment_key')
    localStorage.removeItem('displayInfo')

    // Vue.routerInstance.push('/financial-statements')
    Vue.routerInstance.push('/')
  },
  [USER_LOGOUT]: (state, payload = '') => {
    state.isLoggedIn = false
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    localStorage.removeItem('miscData')
    localStorage.removeItem('financialObjTemp')
    localStorage.removeItem('codesObject')
    localStorage.removeItem('inputOneSelectedData')
    localStorage.removeItem('outputData')
    localStorage.removeItem('financial_statment_key')
    localStorage.removeItem('displayInfo')
    console.log('logout', window.root.$route)
    if (!window.root.$route.path === '/login') {
      Vue.routerInstance.push('/')
    } else {
      Vue.routerInstance.push('/login')
    }
  },
  [UPDATELOGGEDINUSER]: (state, user) => {
    console.log('Before', state.loggedInUser)
    // console.log('local storage Before', localStorage.getItem('user'))
    if (user.data['Error'] !== undefined) {
      state.loggedInUser = user.data['User']
      localStorage.setItem('user', JSON.stringify(user.data['User']))
      return 'saved'
    } else {
      state.loggedInUser = user.data
      console.log('AFTER', state.loggedInUser)
      localStorage.setItem('user', JSON.stringify(user.data))
      return 'saved'
    }
  },
  'MountUserForMainJS': (state) => {
    state.isLoggedIn = true
    state.loggedInUser = JSON.parse(localStorage.getItem('user'))
  },
  'DISPLAYTOAST': (state, status) => {
    state.showToast = status
  }
}

const actions = {
  /**
   * User Login
   */
  [USER_LOGIN]: async ({ commit }, loginData) => {
    commit('FORM_SUBMIT')
    try {
      // commit('ISLOADING', true)
      const result = await UserRepository.login(loginData)
      let token = result.data.token
      let user = result.data.user
      commit(USER_LOGIN, {'token': token, 'loginModalRef': loginData.loginModalRef, 'user': user})
      // commit('ISLOADING', false)
      commit('RESET_SUBMIT')
      return result.data.user
    } catch (error) {
      commit('RESET_SUBMIT')
      commit('NOTIFICATION', error.response.data)
      return error.response.data
    }
  },
  /**
   * User Login using OTP
   */
  [USER_LOGIN_OTP]: async ({ commit }, loginData) => {
    commit('FORM_SUBMIT')
    // commit('ISLOADING', true)
    try {
      const result = await UserRepository.loginWithOtp(loginData)
      let token = result.data.token
      let user = result.data.user
      commit(USER_LOGIN_OTP, {'token': token, 'user': user})
      commit('RESET_SUBMIT')
      // commit('ISLOADING', false)
      return result.data.user
    } catch (error) {
      console.log('error', error)
      commit('RESET_SUBMIT')
      // commit('NOTIFICATION', error.response.data)
      // commit('ISLOADING', false)
      return error.response.data
    }
  },
  /**
   * User SEND OTP
   */
  [SEND_OTP]: async ({ commit }, loginData) => {
    commit('FORM_SUBMIT')
    try {
      const result = await UserRepository.sendOtp(loginData)
      commit('RESET_SUBMIT')
      return result.data
    } catch (error) {
      commit('RESET_SUBMIT')
      commit('NOTIFICATION', error.response.data)
      return error.response.data
    }
  },
  /**
   * User Logout
   */
  [USER_LOGOUT]: ({ commit }) => {
    commit(USER_LOGOUT)
  },
  /**
   * User Register
   */
  [USER_REGISTER]: async ({commit}, registrationData) => {
    // commit('ISLOADING', true)
    try {
      const result = await UserRepository.register(registrationData)
      console.log('UserRegistration', result)
      if (result.errors !== undefined) {
        commit('ERRORS', result.errors)
      } else {
        let token = result.token
        let user = result.user
        commit(USER_LOGIN, {'token': token, 'loginModalRef': false, 'user': user, 'fromRegister': true})
        commit('RESET_SUBMIT')
      }
    } catch (error) {
      commit('RESET_SUBMIT')
      commit('ERRORS', 'Email Already Exist')
    }
    // commit('ISLOADING', false)
  },
  /**
   * User PROFILE
   */
  [USER_PROFILE]: async ({commit}, postData) => {
    // commit('ISLOADING', true)
    try {
      const result = await UserRepository.postUserProfile(postData)
      console.log('User profile ACTION', result.data)
      if (result.data.errors !== undefined) {
        commit('ERRORS', result.data.errors)
      } else {
        commit(UPDATELOGGEDINUSER, result)
        return result.data
      }
      // commit('RESET_SUBMIT')
    } catch (error) {
      console.log('USER PROFILE ERROR', error)
      // commit('RESET_SUBMIT')
      // commit('ERRORS', 'Email Already Exist')
    }
    // commit('ISLOADING', false)
  },
  /**
   * User PROFILE
   */
  [GET_USER_PROFILE]: async ({commit}) => {
    try {
      const result = await UserRepository.getCustomerProfile()
      console.log('User profile ACTION', result.data)
      if (result.data.errors !== undefined) {
        commit('ERRORS', result.data.errors)
      } else {
        commit(UPDATELOGGEDINUSER, result)
        return result.data
      }
      // commit('ISLOADING', false)
    } catch (error) {
      console.log('USER PROFILE ERROR', error)
      // commit('RESET_SUBMIT')
      // commit('ERRORS', 'Email Already Exist')
    }
  },
  /**
   * Change Password
   */
  [CHANGE_PASSWORD]: async ({commit}, passwordData) => {
    // commit('ISLOADING', true)
    try {
      const result = await UserRepository.changePassword(passwordData)
      console.log('Password ACTION', result.data)
      if (result.data.errors !== undefined) {
        console.log('error part')
        commit('ERRORS', result.data.errors)
      } else {
        commit(UPDATELOGGEDINUSER, result)
      }
      // commit('ISLOADING', false)
      return result.data
      // commit('RESET_SUBMIT')
    } catch (error) {
      console.log('Password Change ERROR', error)
      // commit('RESET_SUBMIT')
      commit('ERRORS', error)
    }
    // commit('ISLOADING', false)
  },
  /**
   * update assessment counter user table
   */
  [UPDATELOGGEDINUSER]: ({commit}, data) => {
    if (data['Error'] !== undefined) {
      console.log('action ', data['Error'])
      commit('ERRORS', data['Error'])
    } else {
      commit(UPDATELOGGEDINUSER, {'data': data})
    }
  },
  [FORGOT_PASSWORD]: async ({commit}, data) => {
    try {
      const result = await UserRepository.forgotPassword(data)
      console.log('result.data', result.data)
      return result.data
    } catch (error) {
      return error.response.data
    }
  },
  [RESET_PASSWORD]: async ({commit}, data) => {
    try {
      const result = await UserRepository.resetPassword(data)
      console.log(result)
      return result.data
    } catch (error) {
      console.log('Forgot Password ERROR', error.response.data)
      return error.response.data
    }
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/modules/user.js